export default __webpack_public_path__ + "static/media/shop_bg.6be0276e.jpg";